import { API, AUTH } from "../constants";
import { handleError } from "./RequestErrorService";

export const register = (info, locale, type, params) =>
  fetch(
    API.API_URL +
      AUTH.REGISTER +
      "?" +
      "callback_url=" +
      encodeURIComponent(AUTH.CALLBACK_URL(type, locale)) + 
      params,
    {
      method: "POST",
      headers: headers,
      body: info,
      credentials: 'include'
    }
  ).then(handleError);

export const ssoRegister = (info) =>
  fetch(
    API.API_URL +
      AUTH.REGISTER,
    {
      method: "POST",
      headers: headers,
      body: info
    }
  );

export const checkToken = (token) => 
  fetch(API.API_URL + AUTH.USER_LOGIN, {
    method: "GET",
    headers: {
      authorization: JSON.parse(token),
    },
  }).then(handleError);

export const refreshToken = (info) =>
  fetch(API.API_URL + AUTH.REF_LINK, {
    method: "POST",
    headers: headers,
    body: info
  }).then(handleError);


export const login = (info) =>
  fetch(API.API_URL + AUTH.LOGIN, {
    method: "POST",
    headers: headers,
    body: info
  }).then(handleError);

export const loginFb = (locale, type) =>
  fetch(
    API.API_URL +
      AUTH.LOGIN_FB +
      "?" +
      "callback_url=" +
      AUTH.CALLBACK_URL(type, locale),
    {
      method: "GET"
    }
  ).then(handleError);

export const loginGoogle = (locale, type) =>
  fetch(
    API.API_URL +
      AUTH.LOGIN_GOOGLE +
      "?" +
      "callback_url=" +
      AUTH.CALLBACK_URL(type, locale),
    {
      method: "GET"
    }
  ).then(handleError);


const headers = {
  "Content-Type": "application/json",
  Accept: "application/json"
};
